// Select from props

export const getOrderObjectIdFromProps = (_: unknown, props: { orderObjectId: string }) =>
  props.orderObjectId;
export const getOrderObjectIdsFromProps = (
  _: unknown,
  props: { orderObjectIds: readonly string[] },
) => props.orderObjectIds;
export const getBatchEntryIdFromProps = (_: unknown, props: { batchEntryId: number }) =>
  props.batchEntryId;
export const getBatchEntryIdsFromProps = (_: unknown, props: { batchEntryIds: number[] }) =>
  props.batchEntryIds;

export const getRateObjectIdFromProps = (_: unknown, props: { rateObjectId: string }) =>
  props.rateObjectId;

export const getTransactionObjectIdFromProps = (
  _: unknown,
  props: { transactionObjectId: string },
) => props.transactionObjectId;
